import { preciseCurrencyFormatter } from '@shared/helpers/format-currency';
import { type Product, packMargin } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const MarginDollars: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Margin $',
  minWidth: 60,
  accessorFn: (product) => preciseCurrencyFormatter(packMargin(product)),
  toCSV: (product) => ({
    'Margin $': packMargin(product).toFixed(2),
  }),
  gloss: 'Profit on one pack at the current selling price, in dollars.',
});
